import { types } from 'mobx-state-tree';
import { PaymentWidgetTypeType } from '../types/PaymentWidgetType';

const PaymentWidget = types.model('PaymentWidget', {
  type: PaymentWidgetTypeType,
  script: types.string
});

export default PaymentWidget;



// WEBPACK FOOTER //
// ./src/models/PaymentWidget.js